import Alpine from "alpinejs"

// Counts 0 -> end with an ease-out curve when scrolled into view.
// Usage: <span x-data="countUp(120, '+')" x-intersect.once.half="run()" x-text="display"></span>
Alpine.data("countUp", (end, suffix = "", duration = 1500) => ({
  display: `0${suffix}`,
  run() {
    if (!end) return
    const start = performance.now()
    const step = (now) => {
      const progress = Math.min((now - start) / duration, 1)
      const eased = 1 - Math.pow(1 - progress, 3)
      this.display = Math.round(eased * end) + suffix
      if (progress < 1) requestAnimationFrame(step)
    }
    requestAnimationFrame(step)
  },
}))

// Plays one video and pauses every other one on the page, so two demo clips
// never talk over each other. Mirrors the old video-intersect registry.
window.playOnlyVideo = (video) => {
  document.querySelectorAll("video").forEach((v) => v !== video && v.pause())
  video.play().catch(() => {})
}

// "None" in a checkbox group excludes every other box. Put `data-exclusive`
// and @change="exclusiveNone($event)" on the wrapper around the checkboxes.
window.exclusiveNone = ({ target }) => {
  if (target.type !== "checkbox") return
  target.closest("[data-exclusive]").querySelectorAll("input[type=checkbox]").forEach((box) => {
    if (box !== target && (target.value === "none" ? target.checked : box.value === "none")) box.checked = false
  })
}

// Contact form. Posts to the Pages Function at `endpoint` and renders the error
// codes it returns using this page's localised `messages`. Replaces the Rails
// form_with + turbo_stream re-render.
Alpine.data("contactForm", (messages, endpoint) => ({
  sending: false,
  sent: false,
  errors: {},

  init() {
    this.$el.addEventListener("focusin", () => this.track("lead_form_start"), { once: true })
  },

  // Funnel events for GTM: start -> submit -> success | error. The lead_
  // prefix keeps them apart from GA4's own form_start/form_submit, which
  // can't see a fetch() submission's outcome. Without GTM (previews, local
  // builds) dataLayer is just an array nobody reads.
  track(event, params = {}) {
    ;(window.dataLayer ||= []).push({ event, form: endpoint, ...params })
  },

  async submit(event) {
    this.sending = true
    this.errors = {}
    this.track("lead_form_submit")
    try {
      const response = await fetch(endpoint, {
        method: "POST",
        body: new FormData(event.target),
      })
      const body = await response.json().catch(() => ({}))
      if (response.ok) {
        this.sent = true
        this.track("lead_form_success")
        event.target.reset()
        window.turnstile?.reset()
      } else {
        this.track("lead_form_error", {
          error_codes: Object.values(body.errors || {}).join(",") || `http_${response.status}`,
        })
        // { errors: { phone: "phone_invalid", base: "captcha_failed" } }
        this.errors = Object.fromEntries(
          Object.entries(body.errors || {}).map(([field, code]) => [
            field,
            messages[code] || messages.server_error,
          ])
        )
      }
    } catch {
      this.track("lead_form_error", { error_codes: "network" })
      this.errors = { base: messages.server_error }
    } finally {
      this.sending = false
    }
  },
}))
